import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Blocks from '../blocks/Blocks';
import StyledButton from '../buttons/StyledButton';
import HelpModal from './HelpModal';

import styles from '../../../styles/modals/explanation-modal.module.css';

interface ExplanationModalProps {
    blocks?: Block[];
    url?: string;
    onClose?: () => void;
    withoutButtons?: boolean;
}

const ExplanationModal: React.FC<ExplanationModalProps> = ({
    blocks = null,
    url = null,
    onClose = null,
    withoutButtons = false,
}) => {
    return (
        <HelpModal
            className={classNames([styles.container, 'modal-explanation'])}
            onClose={onClose}
            withCloseButton={withoutButtons}
        >
            <Blocks blocks={blocks || []} />
            {!withoutButtons ? (
                <div className={styles.buttons}>
                    {onClose !== null ? (
                        <StyledButton
                            className={classNames(styles.button, 'button-close')}
                            bordered
                            onClick={onClose}
                        >
                            <FormattedMessage defaultMessage="Cancel" description="Button label" />
                        </StyledButton>
                    ) : null}
                    {url !== null ? (
                        <StyledButton
                            href={url}
                            className={classNames(styles.button, 'button-start')}
                        >
                            <FormattedMessage defaultMessage="Start" description="Button label" />
                        </StyledButton>
                    ) : null}
                </div>
            ) : null}
        </HelpModal>
    );
};

export default ExplanationModal;
